export default __webpack_public_path__ + "static/media/Trapper's Knife.9d703998.jpg";